{
  "loading": "Wird geladen …"
}
